let amplitudeApiKey = "eb5620e68d5fa570a077fcf9cde1080d";
if (window._siteProps_?.props?.build_env_var == "production")
  amplitudeApiKey = "22b51b98c3b678e3bb43761e835025fb";
import { EndPoints } from "../../config/apiEndpoints";

const ORDER_TYPE = {
  DELIVERY: "D", //delivery
  TAKEAWAY: "T",
  PICKUP: "P", //pickup
  IRCTC: "IRCTC",
  DINEIN: "DINEIN", //dineIn
  CURB: "CURB", //drivenpick
};

const PAYMENT_METHOD = {
  CITRUS_WALLET: "PIGGYBANK",
  OTHER_WALLETS: "CASHCRD",
  NET_BANKING: "NB",
  EVOUCHER: "EVOUCHER",
  CASH: "CASH",
  CREDIT_CARD: "CC",
  DEBIT_CARD: "DC",
  AMAZON_WALLET: "AMZPAY_WALLET",
  PAYTM_WALLET: "PAYTM_WALLET",
  UPI_WALLET: "UPI_WALLET",
  MOBILE_BANKING: "MB",
  WALLET: "WALLET",
};

const PAYMENT_ACTION = {
  COD_OTP: "COD_OTP",
  EV_PIN: "EV_PIN",
  EV_OTP: "EV_OTP",
  REDIRECT: "REDIRECT",
  AMZNPAY_CHARGE_STATUS: "AMZNPAY_CHARGE_STATUS",
  PROCESS_PAYMENT: "PROCESS_PAYMENT",
  PAY_PAGE: "PAY_PAGE",
  REMOVE_PROMO: "REMOVE_PROMO",
  REFUND_PAGE: "REFUND_PAGE",
  PAYTM_ADD_MONEY: "PAYTM_ADD_MONEY",
  PAYTM_WITHDRAW_MONEY: "PAYTM_WITHDRAW_MONEY",
  THANKYOU: "THANKYOU",
  PAYTM_LINK: "PAYTM_LINK",
};

const PAYMENT_TRANSACTION_URL =
  EndPoints?.envConfig?.PAYMENT_TRANSACTION_URL || "/paymentTransaction";

const RAZOR_SALT_ID = window._siteProps_?.props?.langPaymentId || "5sga2h";

export default {
  amplitudeApiKey,
  ORDER_TYPE,
  PAYMENT_METHOD,
  PAYMENT_TRANSACTION_URL,
  PAYMENT_ACTION,
  RAZOR_SALT_ID,
};
